// D:\Dabit admin node\src\index.js (সঠিক কোড)

import React from 'react';
// 1. ✅ সঠিক ইম্পোর্ট: অবশ্যই 'react-dom/client' ব্যবহার করতে হবে
import ReactDOM from 'react-dom/client'; 
import './index.css';
import App from './App';
import ImageLoadingFallback from './components/ImageLoadingFallback';
import 'bootstrap/dist/css/bootstrap.min.css';

// 2. ✅ সঠিক রেন্ডারিং পদ্ধতি: ReactDOM.createRoot() ব্যবহার করুন
const rootElement = document.getElementById('root');

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);

    root.render(
        <React.StrictMode>
            <ImageLoadingFallback />
            <App />
        </React.StrictMode>
    );
}
